import React from 'react';
import {usePaymentContext} from '../../contexts/PaymentContext';
import {usePaymentCreditCardContext} from '../../contexts/PaymentCreditCardContex';
import InputCustomerLink from '../InputCustomerLink';

const FieldCustomerLinkCreditCard = () => {
  const {loadCustomerOptions, onCustomerChanged, updateForm} = usePaymentCreditCardContext();
  const {invoiceOrder} = usePaymentContext();

  return (
    <InputCustomerLink
      loadCustomerOptions={loadCustomerOptions}
      onCustomerChanged={onCustomerChanged}
      updateForm={updateForm}
      invoiceOrder={invoiceOrder}
    />
  );
};

export default FieldCustomerLinkCreditCard;